import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { patchUpdateAudioFileName } from '../../services/AudioAnnouncementService';
import type {
  UpdateAudioFileNameRequest,
  AudioAnnouncementFile,
} from '../../types/AudioAnnouncement';

type Result = UseMutationResult<AudioAnnouncementFile, Error, UpdateAudioFileNameRequest>;

function usePatchAudioAnnouncementFileName(
  successCb: () => void,
  failureCb: (error: string) => void,
): Result {
  const queryClient = useQueryClient();

  return useMutation(patchUpdateAudioFileName, {
    onSuccess: (_, variables) => {
      successCb();
      queryClient.invalidateQueries({
        queryKey: ['audio-announcement', variables.fleetId],
      });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePatchAudioAnnouncementFileName;
